import classNames from 'classnames';

import { Accordion, AccordionDetails, AccordionSummary } from '@uikit';

import { MinusSoft } from '@uikit/icons/MinusSoft';
import { PlusSoft } from '@uikit/icons/PlusSoft';

interface Faq {
  answer: string;
  question: string;
}

const AppFaq = ({ faq, appName }: { faq: Faq[]; appName: string }) => {
  if (!faq?.length) {
    return null;
  }

  return (
    <section className="sm:app-page-section-card flex flex-col gap-8">
      <h3 className="text-3xl font-semibold">{appName} FAQ</h3>

      <div className="flex flex-col">
        {faq.map((faqEl, index) => (
          <Accordion
            key={faqEl.question}
            className={classNames('w-full border-primary-200', {
              'border-b': index < faq.length - 1,
            })}
          >
            <AccordionSummary
              expandIcon={<PlusSoft />}
              collapseIcon={<MinusSoft />}
              className="w-full t-subtitle1 h-24 py-4"
              iconClassName={'icon'}
            >
              <h6
                className="text-xl font-semibold"
                dangerouslySetInnerHTML={{ __html: faqEl.question }}
              />
            </AccordionSummary>

            <AccordionDetails>
              <div
                className="inner-html pb-4 leading-8"
                dangerouslySetInnerHTML={{ __html: faqEl.answer }}
              />
            </AccordionDetails>
          </Accordion>
        ))}
      </div>
    </section>
  );
};

export default AppFaq;
